<div [loading]="loading">
  <div *ngIf="!loading">
    <title-detail-create-case-select-objects-items
      [data]="data"
      [checklistGroup]="checklistGroup"
      [checklistEasement]="checklistEasement"
      [checklistConstructionObject]="checklistConstructionObject"
      [checklistBuilding]="checklistBuilding"
      [checklistOwnership]="checklistOwnership"
      [titleId]="titleId"
      [titleDataPromise]="titleDataPromise"
      [generalDataPromise]="generalDataPromise"
      (callbackRegister)="callbackRegister($event)"
    ></title-detail-create-case-select-objects-items>

    <div *ngIf="data.obligation.type === 'ExchangeContractLiability'">
      <gmt-labeled-block label="Parcely investora">
        <create-case-select-external-parcels (selected)="onParcelsExternalSelected($event)"></create-case-select-external-parcels>
      </gmt-labeled-block>
    </div>

    <div *ngIf="data.obligation.type === 'InnominateSalesContractLiability'" class="mt-20">
      <gmt-labeled-block label="Předmět případu">
        <fieldset class="no-legend">
          <div class="column-100">
            <label class="required">Popis</label>

            <textarea [(ngModel)]="data.innominationSubject"></textarea>
          </div>
          <div class="column-100">
            <label class="required">Cena [<span class="unit">Kč</span>]</label>
            <div class="input"><input type="text" [(ngModel)]="data.innominationPrice" gmtInputNumber/></div>
          </div>
        </fieldset>
      </gmt-labeled-block>
    </div>

    <div class="mt-20">
      <gmt-labeled-block label="Osoby">
        <div class="bordered">
          <table *ngIf="selection && (data.obligation.type !== 'InnominateSalesContractLiability' || checklistOwnership.checkedItems.length)">
            <thead>
              <tr>
                <th class="min"><gmt-checkbox *ngIf="data.obligation.type !== 'InnominateSalesContractLiability'" (click)="onSelectAllOwnerships()" [gmtChecked]="selection?.checkedAllOwnerships.value"></gmt-checkbox></th>
                <th>Osoba</th>
                <th *ngIf="data.obligation.type !== 'InnominateSalesContractLiability'">Typ</th>
                <th *ngIf="data.obligation.type !== 'InnominateSalesContractLiability'">Podíl</th>
                <th>Adresa</th>
                <th>Rodné číslo / IČ</th>
              </tr>
            </thead>
            <tbody *ngFor="let itemOwnership of (data.obligation.type !== 'InnominateSalesContractLiability' ? dataOwnerships : checklistOwnership.checkedItems); let $indexOwnership = index" class="hover">
              <tr *ngFor="let itemSubject of itemOwnership.ownership.subjects; let $index = index" (click)="selection?.toggleSelectionOwnership(itemOwnership)">
                <td *ngIf="$index === 0" [attr.rowspan]="itemOwnership.ownership.subjects.length">
                  <gmt-checkbox [gmtChecked]="checklistOwnership.isChecked(itemOwnership)" [gmtDisabled]="!selection?.isOwnershipEnabled(itemOwnership)"></gmt-checkbox>
                </td>
                <td><a uiSref="symap.project.owners.detail" [uiParams]="{ownerId: itemSubject.id, tab: 'about'}">{{itemSubject | subjectName}}</a></td>
                <td *ngIf="$index === 0 && data.obligation.type !== 'InnominateSalesContractLiability'" [attr.rowspan]="itemOwnership.ownership.subjects.length">{{itemOwnership.ownership.typravNazev}}</td>
                <td *ngIf="$index === 0 && data.obligation.type !== 'InnominateSalesContractLiability'" [attr.rowspan]="itemOwnership.ownership.subjects.length" class="number">
                  {{itemOwnership.ownership.podilCitatel}}/{{itemOwnership.ownership.podilJmenovatel}}
                </td>
                <td>
                  {{itemSubject|address}}
                </td>
                <td class="number">
                  {{itemSubject.rodneCislo|personalNumber}}{{itemSubject.rodneCislo && itemSubject.ico !== 1 && itemSubject.ico ? ' / ' : ''}}{{itemSubject.ico !== 1 ? itemSubject.ico : ''}}
                </td>
              </tr>
              <tr class="error-message" *ngIf="!selection?.isOwnershipEnabled(itemOwnership)" [ngClass]="{'bordered-bottom': $indexOwnership < dataOwnerships.length - 1}">
                <td class="bordered-right__none text-center"><i class="fa fa-exclamation-triangle"></i></td>
                <td colspan="5" class="bordered-top bordered-left__none"><div *ngFor="let msg of selection.getOwnershipDisabledMessage(itemOwnership)">{{msg}}</div></td>
              </tr>
            </tbody>
          </table>
          <div class="empty-info" *ngIf="data.obligation.type === 'InnominateSalesContractLiability' && !checklistOwnership.checkedItems.length">
            Žádné vybrané osoby
          </div>
        </div>

        <div *ngIf="data.obligation.type === 'InnominateSalesContractLiability' && selection" class="clearfix">
          <div class="column-100 mt-5">
            <div class="input">
              <gmt-select [reloadOptionsRegister]="selection?.subjectReloadRegister" [itemPipe]="subjectNamePipe" [data]="dataSubject" field="subjects" resource="subjects" [filter]="{filters: {validity: 'valid'}, sortOrder: {sortBy: 'prijmeni'}}" (changed)="selection.subjectChanged($event.newValue);dataSubject.subjects = null;"></gmt-select>
              <a class="button ml-5" (click)="selection?.createSubject()" title="Nová osoba"><span class="fa fa-plus"></span></a>
            </div>
          </div>
        </div>
      </gmt-labeled-block>
    </div>

    <div class="mt-20" *ngIf="isLesseeAllowed()">
      <gmt-labeled-block label="Pachtýř">
        <gmt-lessee-select [selection]="lesseeSelection"></gmt-lessee-select>
      </gmt-labeled-block>
    </div>

    <div class="mt-10">
      <div *ngIf="onlyOneOwnerNeeded" class="error-message mb-10">Pro tento typ případu lze zvolit pouze jednoho vlastníka.</div>
      <div *ngIf="allOwnersNeeded" class="error-message mb-10">Pro tento typ případu musí být vybráni všichni vlastníci.</div>

      <gmt-button [clickAction]="submit" [gmtDisabled]="!isSelectionValid()">Další</gmt-button>
    </div>
  </div>
</div>
